// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3Ryta","header":"ClearentDisclaimer_header__2aijJ","inner":"ClearentDisclaimer_inner__3FU_R"};